import React, { FC, ReactNode } from "react";
import "./Typhography.scss";

type TextStyle = `${"regular" | "medium" | "bold"}-${
  | "10"
  | "12"
  | "14"
  | "16"
  | "20"
  | "24"
  | "32"
  | "40"}`;

interface ITyphography {
  type?: "p" | "h1" | "h2" | "h3" | "h4" | "h5" | "span";
  size?: TextStyle;
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const Typhography: FC<ITyphography> = ({
  type = "p",
  size = "regular-14",
  className = "",
  children,
  style,
  title,
}) => {
  const renderTyphography = () => {
    const props = { className: `text-${size} ${className}`, style, title };
    switch (type) {
      case "p":
        return <p {...props}>{children}</p>;
      case "span":
        return <span {...props}>{children}</span>;
      case "h1":
        return <h1 {...props}>{children}</h1>;
      case "h2":
        return <h2 {...props}>{children}</h2>;
      case "h3":
        return <h3 {...props}>{children}</h3>;
      case "h4":
        return <h4 {...props}>{children}</h4>;
      case "h5":
        return <h5 {...props}>{children}</h5>;

      default:
        return <></>;
    }
  };

  return renderTyphography();
};

export default Typhography;
